// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"899bf7ee","775":"73bb5dab"}[chunkId] + ".chunk.js";
};